document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.petmarket-tabs-section').forEach(function (section) {
    const btns = section.querySelectorAll('.pm-tab-btn');
    const panels = section.querySelectorAll('.pm-tab-panel');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = this.dataset.tab;

        btns.forEach(function (b) {
          b.classList.remove('pm-tab-btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.hidden = true;
        });

        this.classList.add('pm-tab-btn--active');
        this.setAttribute('aria-selected', 'true');

        const panel = section.querySelector('#pm-tab-' + target);
        if (panel) panel.hidden = false;
      });
    });
  });
});
